import PropTypes from 'prop-types'

import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'

import FilterBasicLabelVisible from './Visible.js'

const FilterBasicLabel = ({description, htmlFor, label, nodeLabel, showLabel}) =>
  showLabel ? (
    <FilterBasicLabelVisible description={description} htmlFor={htmlFor} label={label} nodeLabel={nodeLabel} />
  ) : (
    <VisuallyHidden as="label" htmlFor={htmlFor}>
      {label}
    </VisuallyHidden>
  )

FilterBasicLabel.displayName = 'FilterBasicLabel'
FilterBasicLabel.propTypes = {
  description: PropTypes.string,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  nodeLabel: PropTypes.node,
  showLabel: PropTypes.bool
}

export default FilterBasicLabel
